// src/services/assignmentRuleService.js
import { authenticatedFetch } from './api'; // Assuming 'api.js' exports 'authenticatedFetch'

/**
 * Fetches all assignment rules with details (joined zone and team names).
 * @returns {Promise<Array>} A list of assignment rule objects.
 */
export const fetchAssignmentRules = async () => {
    return await authenticatedFetch('/assignment-rules');
};

/**
 * Creates a new assignment rule.
 * @param {object} ruleData - Data for the new rule.
 * Expected format: { rule_name, zone_id, work_order_type, assigned_team_id, priority, is_enabled }
 * @returns {Promise<Object>} The newly created rule object.
 */
export const createAssignmentRule = async (ruleData) => {
    return await authenticatedFetch('/assignment-rules', {
        method: 'POST',
        body: JSON.stringify(ruleData),
    });
};

/**
 * Updates an existing assignment rule.
 * @param {number} id - The ID of the rule to update.
 * @param {object} ruleData - The updated data for the rule.
 * @returns {Promise<Object>} The updated rule object.
 */
export const updateAssignmentRule = async (id, ruleData) => {
    return await authenticatedFetch(`/assignment-rules/${id}`, {
        method: 'PUT',
        body: JSON.stringify(ruleData),
    });
};

/**
 * Deletes an assignment rule by its ID.
 * @param {number} id - The ID of the rule to delete.
 * @returns {Promise<void>}
 */
export const deleteAssignmentRule = async (id) => {
    await authenticatedFetch(`/assignment-rules/${id}`, {
        method: 'DELETE',
    });
};